import 'slick-carousel';
const $ = window.jQuery;
const $window = window.$window || $(window);


const Gallery = {


  init () {
    var $gallery = $('.gallery');
    if (!$gallery.length)
        return;
    
    
    var slick = createSlick();

    function createSlick() {
  
      $gallery.each(function(i,el){
        let $slider = $(this).find('.slick');
        $slider.slick({
          arrows:false,
          slidesToShow:2,
          autoplay: true,
          autoplaySpeed: 2000,
          appendArrows:$(this).find('.arrows-container'),
        });
      });
      
    }
  
  
    $window.resize(function(){
      
      slick.destroy(true);
      slick = createSlick();
      
      
  
    });
  
  }


};

export default Gallery;